// extracted by mini-css-extract-plugin
module.exports = {"flash":"FlashPlayer_flash__xQ7Ad"};